var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"absolute shadow-lg rounded-sm border bg-EXPONDO-primary-5 text-EXPONDO-black z-10"},[_c('span',{staticClass:"text-sm whitespace-nowrap p-2"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }